'use client';
import React from 'react';
import Grid from '@mui/material/Grid2';
import TextFieldComponent from '../../components/form/TextFieldComponent';
import SelectFieldComponent from '../../components/form/SelectFieldComponent';
import CheckBoxFieldComponent from '../../components/form/CheckBoxFields';
import { Box, Button, Paper } from '@mui/material';
import ResetButtonComponent from '../../components/form/ResetButtonComponent';
import FormFieldData, { funcType } from '../../Models/FormFieldData';
import DragAndDropFileUploadWithBrowse from '../FileUploadComponentWithBrowse';
import TextFieldAreaComponent from './TextFieldAreaComponent';
import DatePickerComponent from '../DatePickerComponent';
import SwitchComponent from '../SwitchComponent';
import AutoCompleteTextFieldComponent from './AutoCompleteTextFieldComponent';
import DragAndDropFileUpload from '../FileUploadComponent';
import GoogleMapTextFieldComponent from './GoogleMapTextFieldComponent';
interface CommonFormProps {
  formTitle: string;
  fields: FormFieldData[];
  formReset: () => void;
  onCancel: () => void;
  onSave: () => void;
  isUpdate: boolean;
  isLoading: boolean;
  customComponents?: any;
  isRemoveCancel?: boolean;
  actionButtonPosition: string;
  singlePage?: boolean;
  isHideAction?: boolean;
  elevationPaper?: number;
}
const CommonForm: React.FC<CommonFormProps> = ({
  formTitle,
  fields,
  formReset,
  onCancel,
  onSave,
  isUpdate,
  isLoading,
  customComponents,
  isRemoveCancel,
  actionButtonPosition,
  singlePage,
  isHideAction,
  elevationPaper,
}) => {
  const [fieldErrors, setFieldErrors] = React.useState<Record<string, string>>(
    {}
  );
  const validateFields = (fieldData: any, event?: any) => {
    let errors: any = [];
    setFieldErrors((prevErrors) => {
      errors = { ...prevErrors };

      if (fieldData === 'all') {
        // Validate all fields
        fields.forEach((field) => {
          if (field.validationRules) {
            for (const rule of field.validationRules) {
              const errorMessage = rule(field.value);
              if (errorMessage) {
                errors[field.name] = errorMessage;
                break;
              } else {
                delete errors[field.name];
              }
            }
          }
        });
      } else {
        // Validate single field
        if (fieldData.validationRules) {
          let hasError = false;
          for (const rule of fieldData.validationRules) {
            let errorMessage: any = null;
            if (fieldData.type === 'file') {
              errorMessage = rule(event);
              console.log(rule(event));
            } else {
              event
                ? (errorMessage = rule(event.target.value))
                : (errorMessage = rule(fieldData.value));
            }
            if (errorMessage) {
              errors[fieldData.name] = errorMessage;
              hasError = true;
              break;
            }
          }
          if (!hasError) {
            delete errors[fieldData.name];
          }
        }
      }

      return errors;
    });

    // Check if there are any errors
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    const isValidate = validateFields('all');

    if (isValidate) {
      onSave();
    }
  };
  const getField = (field: FormFieldData) => {
    let fieldElement: any = null;
    switch (field.type) {
      case 'textfield':
        fieldElement = (
          <TextFieldComponent
            type={field.inputType}
            label={field.label}
            keyName={field.name}
            name={field.name}
            value={field.value}
            onChange={field.onChange}
            onBlur={(event) => {
              if (field.onBlur) field.onBlur(event);
              validateFields(field);
            }}
            errorStr={fieldErrors[field.name] || ''}
            isRequired={field.isRequired}
            disabled={field.disabled}
          />
        );
        break;
      case 'GoogleMapTextField':
        fieldElement = (
          <GoogleMapTextFieldComponent
            type={field.inputType}
            label={field.label}
            keyName={field.name}
            name={field.name}
            value={field.value}
            onChange={field.onChange}
            onBlur={() => validateFields(field)}
            errorStr={fieldErrors[field.name] || ''}
            isRequired={field.isRequired}
            disabled={field.disabled}
          />
        );
        break;
      case 'textfieldAutocomplete':
        fieldElement = (
          <AutoCompleteTextFieldComponent
            onChange={field.onChange}
            label={field.label}
            isRequired={field.isRequired}
            value={field.value}
            keyName={field.name}
            name={field.name}
            items={field.options as any[]}
            errorStr={fieldErrors[field.name] || ''}
          />
        );
        break;
      case 'textareaField':
        fieldElement = (
          <TextFieldAreaComponent
            onChange={field.onChange}
            onBlur={() => validateFields(field)}
            label={field.label}
            isRequired={field.isRequired}
            value={field.value}
            keyName={field.keyname}
            name={field.name}
            errorStr={fieldErrors[field.name] || ''}
            minRows={field.minRows}
          />
        );
        break;
      case 'selectField':
        fieldElement = (
          <SelectFieldComponent
            label={field.label}
            isRequired={field.isRequired}
            items={field.options || []}
            keyName={field.name}
            name={field.name}
            value={field.value}
            disabled={field.disabled}
            onChange={(event) => {
              field.onChange(event);
              validateFields(field, event);
            }}
            isHidden={field.isHidden}
            onBlur={() => validateFields(field)}
            errorStr={fieldErrors[field.name] || ''}
          />
        );
        break;
      case 'multicheck':
        fieldElement = (
          <CheckBoxFieldComponent
            checkField={field.value}
            label={field.label}
            errorStr={fieldErrors[field.name] || ''}
            onCheckBoxChange={field.onChange}
            isRequired={field.isRequired}
            items={field.options || []}
            keyName={field.name}
            name={field.name}
          />
        );
        break;
      case 'file':
        fieldElement = (
          <DragAndDropFileUploadWithBrowse
            errorStr={fieldErrors[field.name] || ''}
            label={field.label}
            isHidden={field.isHidden}
            multiple={field.multiple}
            customHeight="65px"
            isRequired={field.isRequired}
            keyName={field.name}
            name={field.name}
            defaultValue={field.value ?? []}
            acceptFiles={field.acceptFiles}
            isCurrentFiles={field.existingFiles}
            onChange={(files) => {
              field.onChange(files);
              validateFields(field, files);
            }}
            handleRemove={(file: any) => {
              field.onRemoveFile ? field.onRemoveFile(file) : console.log(file);
            }}
            handleCurrentFilesRemove={(file: any) => {
              field.onRemoveExistingFile
                ? field.onRemoveExistingFile(file)
                : console.log(file);
            }}
            handleOpen={(id) => {
              field.onOpenFile ? field.onOpenFile(id) : console.log(id);
            }}
          />
        );
        break;
      case 'fileDragAndDrop':
        fieldElement = (
          <DragAndDropFileUpload
            onChange={field.onChange}
            defaultValue={field.value}
            name={field.name}
            keyName={field.name}
            isRequired={field.isRequired}
            label={field.label}
            multiple={field.multiple}
            errorStr={fieldErrors[field.name] || ''}
            handleRemove={field.onRemoveFile as funcType}
            handleCurrentFilesRemove={field.onRemoveExistingFile as funcType}
            handleOpen={field.onOpenFile}
          />
        );
        break;
      case 'datepicker':
        fieldElement = (
          <DatePickerComponent
            name={field.name}
            label={field.label}
            defaultValue={field.value}
            onChange={field.onChange}
            isRequired={field.isRequired}
            keyName={field.keyname as string}
            isHidden={field.isHidden}
            errorStr={fieldErrors[field.name] || ''}
          />
        );
        break;
      case 'switchField':
        fieldElement = (
          <SwitchComponent
            name={field.name}
            label={field.label}
            checked={field.checked ?? false}
            handleInputChange={field.onChange}
            value={field.value}
          />
        );
        break;
      case 'custom':
        fieldElement = <Box>{field.isHidden ? '' : field.customComponent}</Box>;
        break;
      default:
        fieldElement = <Box></Box>;
    }
    return fieldElement;
  };

  const invalidMandatoryFields = Object.values(fields).filter(
    (field) =>
      field.isRequired === true && field.validationRules && !field.value
  );

  return (
    <Box className={singlePage ? '' : 'mainForm dashboardmain'}>
      <Paper
        sx={{ padding: '50px' }}
        elevation={typeof elevationPaper != undefined ? elevationPaper : 1}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {formTitle && <h1>{formTitle}</h1>}
          {actionButtonPosition === 'top' && !isHideAction && (
            <Box>
              {!isRemoveCancel && (
                <ResetButtonComponent
                  keyName={'createbtn'}
                  onClear={formReset}
                />
              )}
              <Button
                id={'formkeybtn'}
                key={'formkeybtn'}
                variant="contained"
                sx={{ bgcolor: '#000b29', color: '#fff' }}
                disabled={isLoading || Object.keys(fieldErrors).length > 0}
                onClick={() => {
                  handleSubmit();
                }}
              >
                {isLoading ? 'Saving wait...' : isUpdate ? 'Update' : 'Add'}
              </Button>
            </Box>
          )}
        </Box>
        <Grid
          container
          spacing={2}
          style={{ width: '100%', textAlign: 'left' }}
        >
          {fields.map((formField: FormFieldData) => {
            return (
              <Grid key={formField.name} size={formField.size}>
                {getField(formField)}
              </Grid>
            );
          })}
          {customComponents && (
            <Grid size={12} sx={{ textAlign: 'right' }}>
              {customComponents}
            </Grid>
          )}
          {actionButtonPosition === 'bottom' && !isHideAction && (
            <Grid size={12} sx={{ textAlign: 'right' }}>
              {!isRemoveCancel && (
                <ResetButtonComponent
                  keyName={'createbtn'}
                  onClear={formReset}
                />
              )}
              <Button
                id={'formkeybtn'}
                key={'formkeybtn'}
                variant="contained"
                sx={{ bgcolor: '#000b29', color: '#fff' }}
                disabled={
                  isLoading ||
                  Object.keys(fieldErrors).length > 0 ||
                  invalidMandatoryFields.length > 0
                }
                onClick={() => {
                  handleSubmit();
                }}
              >
                {isLoading ? 'Saving wait...' : isUpdate ? 'Update' : 'Add'}
              </Button>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Box>
  );
};

export default CommonForm;
